module.exports = __webpack_public_path__ + "static/ecc62ede35e876f56b7b1195e6cddcce8eee0fd620dcc841393c7892e34abd3f-df0f6eb06f2c0d7f1fed9953d7111a79.png";